import './BrandingFooter.scss';

function BrandingFooter() {
    return <div className="brandingFooter">Powered by Faces</div>;
}
export default BrandingFooter;
